module.exports = ".ng-select.text-capitalize{ text-transform: capitalize }\n"